<template>
    <div class="wrap-content ocr-config-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-4">
                    <h2>Customer On Boarding</h2>
                </div>
            </div>
        </div>

        <div class="config-card-switch">
            <div class="row">
                <div v-if="!showPageLoader" class="col-lg-12">
                    <div class="card custom-card">
                        <!-- <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">OCR Switch</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            id="populatedata"
                                            label="Use OCR to populate Data in Registration Form"
                                            label-for="populatedata"
                                        >
                                            <b-form-radio-group
                                                v-model="formData.switch"
                                                :options="ocrSwitch"
                                                name="switch"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Document Upload</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use to upload documents on on-boarding form"
                                            label-for="documentUpload"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.documentUpload
                                                "
                                                :options="radioOptions"
                                                name="documentUpload"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">
                                    Liveness and Facial Comparison Switch
                                </h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use Liveness and Facial comparison while onboarding customers"
                                            label-for="liveness"
                                        >
                                            <b-form-radio-group
                                                v-model="formData2.liveness"
                                                :options="radioOptions"
                                                name="liveness"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Name Screening Switch</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use Name Screening while onboarding customers"
                                            label-for="nameScreening"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.nameScreening
                                                "
                                                :options="radioOptions"
                                                name="nameScreening"
                                                disabled
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Account Info</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use to add Account info tab"
                                            label-for="accountinfo"
                                        >
                                            <b-form-radio-group
                                                v-model="formData2.accountinfo"
                                                :options="radioOptions"
                                                name="accountinfo"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Additional Information</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use to add additional info tab"
                                            label-for="additionalInfo"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.additionalInfo
                                                "
                                                :options="radioOptions"
                                                name="additionalInfo"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">ID Document Number</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Restrict duplicate ID document numbers"
                                            label-for="restrict-duplicate-customers"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.restrictDuplicateCustomers
                                                "
                                                :options="documentOptions"
                                                name="radio-options"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                        <!-- <div class="fields-area"      v-if="isVisible()">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Enable UAE-Specific Profile Fields</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Choose whether to include UAE-specific fields in the onboarding form for UAE customers."
                                            label-for="uaesetupprofile"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.uaepassfield
                                                "
                                                :options="radioOptions"
                                                name="uaepassfield"
                                            
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="brand-color-area">
                            <h5 class="m-b-30">
                                Document Validation and Optical Character
                                Recognition (OCR)
                            </h5>
                            <div class="row">
                                <div class="col-lg-12 form-radio">
                                    <b-form-group
                                        label="Use to validate documents on on-boarding form"
                                        label-for="documentValidation"
                                    >
                                        <em
                                            ><label
                                                >Note: OCR Supports only on
                                                PNG,JPG & JPEG formats</label
                                            ></em
                                        >

                                        <b-form-radio-group
                                            v-model="
                                                formData2.documentValidation
                                            "
                                            :options="radioOptions"
                                            name="documentValidation"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Risk Factor Switch</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use Risk Factor while onboarding customers"
                                            label-for="riskFactor"
                                        >
                                            <b-form-radio-group
                                                v-model="formData2.riskFactor"
                                                :options="radioOptions"
                                                name="riskFactor"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>

                    
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">
                                    Adverse media exact name search
                                </h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Use to get hits of exact name from adverse media"
                                            label-for="exactNameMatch"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.exactNameMatch
                                                "
                                                :options="radioOptions"
                                                name="exactNameMatch"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="countryTemp == 'UAE' && isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">
                                    Allow Onboarding Without UAE Pass
                                </h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Enable or disable onboarding for customers without UAE Pass authentication."
                                            label-for="uaepass"
                                        >
                                            <b-form-radio-group
                                                v-model="formData2.isUaePass"
                                                :options="radioOptions"
                                                name="isUaePass"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="country == 'Pakistan' && isVisible()"
                            class="fields-area"
                        >
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Degree Verification</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Degree verification for on-boarded customers"
                                            label-for="degreeCheck"
                                        >
                                            <b-form-radio-group
                                                v-model="formData2.degreeCheck"
                                                :options="radioOptions"
                                                name="degreeCheck"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="country == 'Pakistan' && isVisible()"
                            class="fields-area"
                        >
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Employment Verification</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Employment verification for on-boarded customers"
                                            label-for="employmentCheck"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.employmentCheck
                                                "
                                                :options="radioOptions"
                                                name="employmentCheck"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Notifications</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Turn on email notification for the expiry of the customer's documents"
                                            label-for="notifications"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.notifications
                                                "
                                                :options="radioOptions"
                                                name="notifications"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Notify Customers</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Turn on email notifications to notify the customers of the expiration of their documents."
                                            label-for="notifyCustomers"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.notifyCustomers
                                                "
                                                :options="radioOptions"
                                                name="notifyCustomers"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Two-Factor Authorization</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="enable 2FA on login"
                                            label-for="twoFA"
                                        >
                                            <b-form-radio-group
                                                v-model="formData2.twoFA.enable"
                                                :options="radioOptions"
                                                name="twoFA"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                    <div
                                        v-if="formData2.twoFA.enable == true"
                                        class="col-lg-12 form-radio"
                                    >
                                        <b-form-group
                                            label="Please select an option for OTP"
                                            label-for="otp"
                                        >
                                            <div class="d-flex">
                                                <b-form-radio-group
                                                    v-model="
                                                        formData2.twoFA.method
                                                    "
                                                    :options="twoFAOptions"
                                                    name="twoFAMethod"
                                                ></b-form-radio-group>
                                                <!--<i v-if="formData2.twoFA.method=='app'" class="icon-settings cursor-pointer d-flex align-items-end py-1" title="View QR Code" @click="scanCode('app','false')"></i>-->
                                                <img
                                                    v-if="
                                                        formData2.twoFA
                                                            .method == 'app'
                                                    "
                                                    class="icon-settings cursor-pointer d-flex align-items-end py-1"
                                                    style="
                                                        width: 15px;
                                                        height: 40px;
                                                    "
                                                    title="View QR Code"
                                                    src="@/assets/images/qr-code-svgrepo-com.svg"
                                                    @click="
                                                        scanCode('app', 'false')
                                                    "
                                                />
                                            </div>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Delta Screening</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Warning: If you turn this off, you will not receive an alert if any of your customers become sanctioned."
                                            label-for="deltaScreening"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.deltaScreening
                                                "
                                                :options="radioOptions"
                                                name="deltaScreening"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Email Customer's Profile</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="To get customer's profile on email, select Yes"
                                            label-for="emailProfile"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.emailProfile
                                                        .status
                                                "
                                                :options="radioOptions"
                                                name="emailProfile"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <b-form-group
                                v-if="emailRequired"
                                id="input-group-1"
                                label="Email"
                                label-for="send-to-email"
                            >
                                <b-form-input
                                    id="send-to-email"
                                    v-model="formData2.emailProfile.email"
                                    v-validate="{
                                        required: emailRequired,
                                        email: true,
                                        max: 50,
                                        min: 5,
                                    }"
                                    type="text"
                                    name="send-to-email"
                                    :class="{
                                        'is-invalid':
                                            errors.has('send-to-email'),
                                    }"
                                    autocomplete="no"
                                    placeholder="Enter Email"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div v-if="user.kyb" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Infection</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Can associated individual alert affect company ?"
                                            label-for="infectionAssociatedIndividual"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.infectionAssociatedIndividual
                                                "
                                                :options="radioOptions"
                                                name="infectionAssociatedIndividual"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isVisible()" class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Auto Approved</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Customer should get auto approved?"
                                            label-for="generateAlertOnLowRisk"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData2.generateAlertOnLowRisk
                                                "
                                                :options="
                                                    autoApprovedRadioOptions
                                                "
                                                name="generateAlertOnLowRisk"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <b-button
                                    type="submit"
                                    variant="primary"
                                    :class="loading ? 'disabled' : ''"
                                    @click.prevent="OnSubmitt()"
                                >
                                    <span class="btn-text">UPDATE</span>
                                    <span class="loader"></span>
                                </b-button>
                                <base-toast></base-toast>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- When data is loading -->
                <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            </div>
        </div>
        <message-popup
            title="Configurations applied successfully"
            :message="popupMessage"
            :on-done="removePopupMessage"
            :on-hidden="removePopupMessage"
        ></message-popup>
        <b-modal
            ref="codemodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <code-popup
                :data="otpData"
                heading="2FA Authentication"
                @generateNew="scanCode"
            ></code-popup>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import MessagePopup from '../../components/popups/MessagePopup.vue'
import CodePopup from '../../components/popups/CodePopup.vue'
const viewOcrResource = new resource('configurations/ocr')
const modulesApi = new resource('configurations/modules')
import axios from 'axios'
export default {
    components: {
        MessagePopup,
        CodePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            otpData: { qrCodeUrl: null, code: null },
            showPageLoader: true,
            query: {
                dataSegmentId: localStorage.getItem('dataSegmentId'),
            },
            formData: {
                // switch: false,
                // restrictDuplicateCustomers: false,
            },
            country: process.env.VUE_APP_COUNTRY,
            countryTemp: process.env.VUE_APP_COUNTRY_TEMP,
            formData2: {
                dataSegmentId: null,
                riskFactor: null,
                liveness: null,
                nameScreening: null,
                documentUpload: null,
                accountinfo: null,
                documentValidation: null,
                additionalInfo: null,
                exactNameMatch: null,
                degreeCheck: null,
                employmentCheck: null,
                notifications: null,
                notifyCustomers: null,
                twoFA: {
                    enable: null,
                    method: null,
                },
                deltaScreening: null,
                restrictDuplicateCustomers: null,
                emailProfile: {
                    email: null,
                    status: false,
                },
                infectionAssociatedIndividual: null,
                generateAlertOnLowRisk: false,
                isUaePass: false,
                uaepassfield: null,
            },
            ocrSwitch: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            radioOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            twoFAOptions: [
                { text: 'Email', value: 'email' },
                { text: 'Authenticator App', value: 'app' },
            ],
            autoApprovedRadioOptions: [
                { text: 'If overall Risk score is low', value: true },
                {
                    text: 'If No Risk factor is high/medium',
                    value: 'Approve Zero Risk',
                },
                { text: 'No', value: false },
            ],
            documentOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            ocrList: [],
            resourceApi: '',
            popupMessage: null,
            isInitialLoad: true,
            isUaePass: null,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'dataSegmentId',
            'loading',
            'data',
            'user',
            'dataSegmentConfigurations',
        ]),

        emailRequired() {
            return this.formData2.emailProfile.status
        },
    }, // End of Component > mounted

    watch: {
        'formData2.twoFA.method': function (newVal, oldVal) {
            if (!this.isInitialLoad) {
                this.scanCode(newVal, 'false')
            } else {
                this.isInitialLoad = false // Set the flag to false after the first execution
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.getOcrData()
                this.getModuleData()
            }
        },
        popupMessage(value) {
            if (value) {
                this.$bvModal.show('message-popup')
            } else {
                this.$bvModal.hide('message-popup')
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getOcrData()
        this.getModuleData()
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async scanCode(val, isNew = 'false') {
            if (val == 'app') {
                this.$store.commit('setLoading', true)
                await axios
                    .get(
                        process.env.VUE_APP_API_URL +
                            'configurations/generate-code?generateNew=' +
                            isNew
                    )
                    .then((response) => {
                        if (response.data && response.data.status) {
                            this.otpData.qrCodeUrl = response.data.data
                            this.otpData.code = response.data.code
                            this.$store.commit(
                                'setSuccess',
                                response.data.message
                            )
                            this.$refs.codemodal.show()
                        } else {
                            this.$store.commit(
                                'setError',
                                'There is an error in generating QR code, please try again.'
                            )
                        }
                        this.$store.commit('setLoading', false)
                    })
                    .catch((error) => {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', error)
                    })
            }
        },
        isVisible() {
            if (this.user.accountType != 'lite') {
                return true
            }
            return false
        },
        async getOcrData() {
            if (this.dataSegmentId) {
                this.query.dataSegmentId = this.dataSegmentId
            }
            let { data } = await viewOcrResource.list(this.query)
            this.formData = data.data
            this.showPageLoader = false
        },

        async updateOnboardingConfiguration() {
            try {
                // update on boarding configuration
                this.$store.commit('setLoading', true)
                let { data } = await viewOcrResource.update(
                    this.formData._id,
                    this.formData
                )
                await viewOcrResource.list(this.query)
                this.$store.commit('setLoading', false)
                this.$store.commit('setSuccess', data.message)
            } catch (error) {
                this.$store.commit(
                    'setError',
                    'There is an error update on boarding configuration'
                )

                console.log(
                    error,
                    'There is an error update on boarding configuration'
                )
            }
        },
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        // console.log(data.data)
                        this.formData2 = data.data
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                this.showPageLoader = false
            }
        },
        async updateModuleConfigurations() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    if (
                        this.formData2.liveness == false &&
                        this.formData2.riskFactor == false &&
                        this.formData2.nameScreening == false &&
                        this.formData2.documentUpload == false
                    ) {
                        this.$store.commit(
                            'setError',
                            'You need to enable at least one onboarding switch'
                        )
                        await this.getModuleData()
                        return false
                    }
                    // update SAR configuration
                    this.$store.commit('setLoading', true)
                    let { data } = await modulesApi.update(
                        this.formData2._id,
                        this.formData2
                    )
                    // console.log('resp----',data)
                    if (data.token) {
                        this.$store.commit('setToken', data.token.token)
                        this.$store.commit(
                            'setTokenExpiry',
                            data.token.expiresIn
                        )
                    }

                    // this.$store.commit('setDataSegmentConfigurations',data.data)
                    // console.log('dataSegmentConfigurations----',this.dataSegmentConfigurations)
                    await this.getModuleData()
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setSuccess', data.message)
                    if (data.popupMessage) {
                        this.popupMessage = data.popupMessage
                    }
                } catch (error) {
                    console.log(error)
                    this.$store.commit('setError', error)
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        },
        removePopupMessage() {
            this.popupMessage = null
        },
        async OnSubmitt() {
            this.updateModuleConfigurations()
            // this.updateOnboardingConfiguration()
        },
    },
} // End of export default
</script>
